import { useEffect } from 'react';
import { getCookie, setCookie } from '../utils/cookieUtils';

export function useSubscriptionProducts({ setSubscriptionProducts, setListProductHandles, setDepositedData, subscriptionProducts, currentDog }) {
	useEffect(() => {
		const jsonDataScripts = /** @type {NodeListOf<HTMLScriptElement>} */ (document.querySelectorAll('script.main__product'));
		let productsDatasets = Array.from(jsonDataScripts).map((script) => script.dataset.productHandle);
		const sessionStorageData = getCookie('_subscriptionMainData');
		let configObject = {};

		if (sessionStorageData) {
			const decodedBtoaa = atob(sessionStorageData);
			const textDecoder = new TextDecoder('utf-8');
			const decodedString = textDecoder.decode(new Uint8Array(decodedBtoaa.split('').map((c) => c.charCodeAt(0))));
			const decodedData = JSON.parse(decodedString);
			configObject = decodedData;

			if (!subscriptionProducts) {
				setSubscriptionProducts(decodedData);
			}

			const availableProducts = productsDatasets.filter(
				(handle) => window.store?.reviewsData?.[handle]?.available !== undefined ? window.store?.reviewsData?.[handle]?.available === 'true' : configObject[handle]?.fetchData?.available !== false
			);

			setListProductHandles(productsDatasets);

			setDepositedData((prevState) => {
				prevState[currentDog] = {
					...prevState[currentDog],
					products: availableProducts,
					discount: availableProducts.length * 5 > 20 ? 20 : availableProducts.length * 5,
				};
				return prevState;
			});
		} else {
			const fetchMainProduct = productsDatasets.map((productHandle) => {
				return fetch(`/products/${productHandle}.js`).then((response) => response.json());
			});

			Promise.all(fetchMainProduct).then((data) => {
				if (!subscriptionProducts) {
					data.forEach((product) => {
						configObject[product.handle] = configObject[product.handle] || {};
						configObject[product.handle]['fetchData'] = product;
					});

					Array.from(jsonDataScripts).forEach((script) => {
						const parsedJson = JSON.parse(script.innerHTML);
						const handle = script.dataset.productHandle;

						configObject[handle]['dosages'] = parsedJson[0].dosages;
						configObject[handle]['markup_product_grid'] = parsedJson[0].markup_product_grid;
						configObject[handle]['product_instructions'] = parsedJson[0].product_instructions;
						configObject[handle]['price_display'] = parsedJson[0].price_display;
						configObject[handle]['label'] = parsedJson[0].label;
					});

					const sessionData = btoa(unescape(encodeURIComponent(JSON.stringify(configObject)).replace(/(?:\\[rn])+/g, '')));
					setCookie('_subscriptionMainData', sessionData, 1);
					setSubscriptionProducts(configObject);

					const availableProducts = productsDatasets.filter(
						(handle) => window.store?.reviewsData?.[handle]?.available !== undefined ? window.store?.reviewsData?.[handle]?.available === 'true' : configObject[handle]?.fetchData?.available !== false
					);


					setListProductHandles(productsDatasets);

					setDepositedData((prevState) => {
						prevState[currentDog] = {
							...prevState[currentDog],
							products: availableProducts,
							discount: availableProducts.length * 5 > 20 ? 20 : availableProducts.length * 5,
						};
						return prevState;
					});
				}
			});
		}
	}, []);
}
